/**
 * Labels for question response statuses used in pie charts and UI elements.
 */
export const QUESTION_RESPONSE_LABELS = {
  PASS: 'Pass',
  FAIL: 'Fail',
  NA: 'N/A',
  UNANSWERED: 'Unanswered',
} as const;

/**
 * Color constants for question response statuses used in pie charts and UI elements.
 */
export const QUESTION_RESPONSE_COLORS = {
  PASS: '#00802f',
  FAIL: '#db0000',
  NA: '#006ce0',
  UNANSWERED: '#b4b4bb',
} as const;

export type QuestionResponseLabel =
  (typeof QUESTION_RESPONSE_LABELS)[keyof typeof QUESTION_RESPONSE_LABELS];

export type QuestionResponseColor =
  (typeof QUESTION_RESPONSE_COLORS)[keyof typeof QUESTION_RESPONSE_COLORS];
